<template>
  <div class="myIntegral">
    <ul class="myIntegralForm" v-if="myIntegral">
      <li class="myIntegralFormTitle">
        <div class="titleInner">积分来源</div>
        <div class="titleInner">积分变化</div>
        <div class="titleInner">日期</div>
      </li>
      <li class="myIntegralList" v-for="(item, index) in myIntegral" :key="index">
        <div class="overell">{{item.ruleName}}</div>
        <div :class="item.getIntegral < 0?'green':'red'"><span v-if="item.getIntegral > 0">+</span>{{item.getIntegral}}</div>
        <div>{{item.createTime}}</div>
      </li>
    </ul>
    <div class="doclist-pagination" v-if="myIntegral">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':'pageDeavtive'" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      myIntegral: null,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getUserPointList()
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getUserPointList()
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getUserPointList () {
      this.$request.postParam(`/front/train/forum/integralOrder/userPointList`, {
        page: this.currentPage,
        limit: 10
      })
        .then((data) => {
          if (data.code === 0) {
            this.myIntegral = data.data || []
            this.totalPage = Math.ceil(data.count / 10)
            let newPageList = []
            if (this.totalPage <= 5) {
              for (let i = 1; i <= this.totalPage; i++) {
                newPageList.push(i)
              }
              this.pageList = newPageList
              this.nextOmit = ''
            }
          }
        })
        .catch(error => {
          this.$message.error(error.response.data.message)
        })
    }
  },
  created () {
    this.getUserPointList()
  }
}
</script>

<style scoped>
.myIntegral{
  width: 1190px;
  background: #ffffff;
  padding-bottom: 30px;
}
.myIntegralForm{
  background: #eeeeee;
}
.myIntegralFormTitle{
  color: #999999;
  background: #eeeeee;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  display: flex;
}
.titleInner{
  flex: 1;
  text-align: center;
}
.myIntegralList{
  background: #ffffff;
  display: flex;
  height: 74px;
  color: #333333;
}
.myIntegralList div{
  flex: 1;
  text-align: center;
  line-height: 74px;
  font-size: 16px;
  box-sizing: border-box;
  border-right: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.myIntegralList div:nth-of-type(3){
  border-right: 0;
}
.green{
  color: #61ba00;
}
.red{
  color: #bf1b22;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 245px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
.pageDeavtive{
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 分页区域样式结束 */
</style>
